import { Controller } from "@hotwired/stimulus"
import { isValueChangingKey } from "../keyboard";

// Connects to data-controller="review-bill-items"
export default class extends Controller {
  static targets = [
    "rowsContainer",
    "totalsRow",
    "numBillItems",
    "totalCost",
    // These targets are optional, and only exist if we're looking at an EOB.
    // Stimulus doesn't seem to handle optional targets like I would expect, so we'll fall back to plain JS for these.
    // "totalAllowed",
    // "totalPatientResponsibility",
    "form",
    "markAllReviewed"
  ]

  initialize() {
    this.activeFormElement = null;
    this.newRowHtml = null;
  }

  connect() {
  }

  changeActiveFormElement(event) {
    this.activeFormElement = event.target
  }

  onInputChange(event) {
    // If an input element is changed, we disable these buttons.  Once the user clicks [Save], the form is refreshed and
    // the buttons are re-enabled.
    this.markAllReviewedTarget.disabled = true;
  }

  onKeyUp(event) {
    // If the user pressed a key and it's the kind of key that causes a change (e.g. a letter, versus just an arrow key),
    // then disable the buttons.  This acts a little faster than onInputChange because it doesn't require changing focus
    // from the field.
    if(event.key && isValueChangingKey(event.which)) {
      this.markAllReviewedTarget.disabled = true;
    }
  }

  addRow() {
    // i wanted to keep HTML out of JS, so even though this is really just placing static HTML into the page, i figured i'd do it
    // by first making an ajax call to the server, and then storing the response so we don't have to do that every single time
    // we want to add a new row
    if (this.newRowHtml === null) {
      $.ajax({
        type: 'GET',
        url: this.rowsContainerTarget.dataset['addRowUrl'],
        success: (response) => {
          var row = document.createElement("tr")
          row.innerHTML = response
          this.newRowHtml = response
          this.rowsContainerTarget.insertBefore(row, this.totalsRowTarget);
          this.updateAllTotals();
          var e = this.findNextFormElement()
          if (e) {
            this.activeFormElement = e
            this.focusOnElement(e)
          }
        }
      })  
    } else {
      var row = document.createElement("tr")
      row.innerHTML = this.newRowHtml
      this.rowsContainerTarget.insertBefore(row, this.totalsRowTarget);
      this.updateAllTotals();
      var e = this.findNextFormElement()
      if (e) {
        this.activeFormElement = e
        this.focusOnElement(e)
      }
    }
  }
  
  removeRow(e) {
    // This just removes the <tr> from the DOM.  The underlying BillItem only gets deleted when you call Save on the form.
    e.target.closest('tr').remove();
    this.updateAllTotals();
  }

  assignValue(event) {
    var value = event.target.dataset['value'];

    if (!this.activeFormElement) {
      return
    }

    // Strip the value down to a number.  Keep only - . and digits.
    if (this.activeFormElement.getAttribute("type") == "number") {
      value = value.match(/[\-\d\.]+/g);
      if (value) {
        value = value.join('');
      }
    }
    this.activeFormElement.value = value;

    var workingOnBillItems = this.rowsContainerTarget.contains(this.activeFormElement);

    // after setting, move to the next element
    var e = this.findNextFormElement()

    if (workingOnBillItems && (e == null || !this.rowsContainerTarget.contains(e))) {
      this.addRow()
    } else if (e) {
      this.focusOnElement(e);
    }

    // mark what we've clicked with a little opacity change
    event.target.classList.add("bg-red")
    event.target.classList.add("opacity-50")
  }

  focusOnElement(elm) {
    elm.focus()
  }

  findNextFormElement() {
    var foundActiveElement = false
    var e = null
    for (var i = 0, elm; elm = this.formTarget.elements[i]; i++) {
      // it needs to be an input that is visible (checked with offsetwidth and offsetheight)
      if (
        foundActiveElement &&
        (elm.nodeName.toLowerCase() === "input" || elm.nodeName.toLowerCase() === "select") &&
        (elm.offsetWidth > 0 || elm.offsetHeight > 0)
      ) {
        e = elm
        break
      }
      else if (elm === this.activeFormElement) {
        foundActiveElement = true
      }
    }

    return e
  }

  updateAllTotals() {
    this.updateTotalCost();
    this.updateTotalAllowed();
    this.updateTotalPatientResponsibility();
  }

  updateTotalCost(e) {
    this.updateTotalField('cost', this.totalCostTarget);
  }

  updateTotalAllowed(e) {
    var element = document.getElementById('total-allowed');
    if (element) {
      this.updateTotalField('allowed_rate', element);
    }
  }

  updateTotalPatientResponsibility(e) {
    var element = document.getElementById('total-patient-responsibility');
    if (element) {
      this.updateTotalField('patient_responsibility', element);
    }
  }

  updateTotalField(fieldName, totalTarget) {
    var numBillItems = 0;
    var total = 0;

    // Find all the cost input elements
    const allInputs = this.element.getElementsByTagName('input');
    for (var i = 0; i < allInputs.length; i++) {
      if (allInputs[i].name.indexOf(fieldName) >= 0) {
        numBillItems += 1;
        total += Number(allInputs[i].value);
      }
    }

    this.numBillItemsTarget.innerText = numBillItems;
    totalTarget.innerText = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total);
  }
}
